import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import styled from 'foundations-theming-specialty/utils';
import { RelativeTime } from './RelativeTime';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StatusDot = styled.span.withConfig({
  displayName: "InboxNavTicketRowHeader__StatusDot"
})(["display:inline-block;inline-size:8px;block-size:8px;border-radius:", ";background-color:", ";flex-shrink:0;"], ({
  theme
}) => theme.borderRadius.full, ({
  theme,
  $variant
}) => $variant === 'open' ? theme.color['fill-positive-default'] : theme.color['text-core-subtle']);
export function InboxNavTicketRowHeader({
  title,
  timestamp,
  showOpenDot,
  showClosedDot
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    gap: "200",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      flexShrink: 1,
      minInlineSize: "0",
      children: [(showOpenDot || showClosedDot) && /*#__PURE__*/_jsx(StatusDot, {
        $variant: showOpenDot ? 'open' : 'closed',
        "data-test-id": "inbox-nav-status-dot"
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        color: "text-core-default",
        truncate: true,
        children: title
      })]
    }), timestamp && /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      color: "text-core-subtle",
      whiteSpace: "nowrap",
      children: /*#__PURE__*/_jsx(RelativeTime, {
        timestamp: timestamp
      })
    })]
  });
}